import React from 'react';
import { elements } from '@ecosystem/newron-design-system';

import * as styles from './ActionBar.module.scss';

export interface ActionBarProps {
  isHidden?: boolean;
  leftMessage?: string;
  centerMessage?: string;
  rightMessage?: string;
  children?: React.ReactNode;
}

const NoticeMessage = ({ text }: { text?: string }): JSX.Element | null => {
  if (!text) {
    return null;
  }
  const { Icon } = elements;
  const { Help: HelpIcon } = Icon.icons;
  return (
    <div className="flex items-center">
      <Icon>
        <HelpIcon />
      </Icon>
      <div data-test-id="compare-info" className="text-xs pl-3">
        {text}
      </div>
    </div>
  );
};

const ActionBar = (props: ActionBarProps): JSX.Element | null => {
  const { leftMessage, isHidden, centerMessage, rightMessage, ...rest } = props;

  if (isHidden) {
    return null;
  }

  return (
    <div className={`bg-medium text-default text-md px-2 py-4 sticky bottom-0`} data-test-id="action-bar">
      <div className="flex items-center h-full justify-between">
        <div className={styles.ActionBar__Selection}>
          {leftMessage && <div data-test-id="selection-info">{leftMessage}</div>}
        </div>
        <div className={styles.ActionBar__Content}>
          <NoticeMessage text={centerMessage} />
        </div>
        <div className={`${styles.ActionBar__Actions} flex`}>
          {rightMessage ? <p data-test-id="no-selection-info">{rightMessage}</p> : rest.children}
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
